import React from 'react';
import { rem } from 'polished';
import iconPaths from '../data/selection.json';
import iconPropTypes from '../prop-types/iconPropTypes';

var getPath = function getPath(iconName) {
  var icons = iconPaths.icons.find(function (icon) {
    return icon.properties.name === iconName;
  });

  if (icons) {
    return icons.icon.paths.join(' ');
  }

  console.warn("icon " + iconName + " does not exist."); // eslint-disable-line no-console

  return '';
};

var getSizes = function getSizes(iconName) {
  var width;
  var height;
  var icons = iconPaths.icons.find(function (icon) {
    return icon.properties.name === iconName;
  });

  if (icons.icon.width) {
    width = icons.icon.width;
    height = 1024;
    return {
      width: width,
      height: height
    };
  }

  return {
    width: 1024,
    height: 1024
  };
};

var GaIcon = function GaIcon(_ref) {
  var color = _ref.color,
      size = _ref.size,
      icon = _ref.icon;
  var styles = {
    svg: {
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    path: {
      fill: color
    }
  };

  if (!icon) {
    return null;
  }

  return /*#__PURE__*/React.createElement("svg", {
    style: styles.svg,
    width: rem(size),
    height: rem(size),
    viewBox: "0 0 " + getSizes(icon).width + " " + getSizes(icon).height
  }, /*#__PURE__*/React.createElement("path", {
    style: styles.path,
    d: getPath(icon)
  }));
};

GaIcon.defaultProps = {
  size: 22,
  color: 'currentColor'
};
export default GaIcon;